import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { BulkUpdateSettingsInput, BulkUpdateSettingsResponse } from '../types';

const bulkUpdateSettingsMutation = gql`
  mutation BulkUpdateSettings($input: BulkUpdateSettingsInput!) {
    payrollBulkUpdateSettings(input: $input) {
      success
      message
      code
      data
    }
  }
`;

export const bulkUpdateSettings = (
  input: BulkUpdateSettingsInput,
): Promise<{ payrollBulkUpdateSettings: BulkUpdateSettingsResponse }> => {
  return graphQLApi<
    { payrollBulkUpdateSettings: BulkUpdateSettingsResponse },
    { input: BulkUpdateSettingsInput }
  >({
    query: bulkUpdateSettingsMutation,
    queryVariables: {
      input,
    },
  });
};
